import React from 'react';
import { Card, CardHead, Metric, BarRow, Pill } from '../components/UI';
import s from './Dashboard.module.css';

export default function Dashboard({ navigate }) {
  return (
    <div>
      {/* Metrics */}
      <div className={s.metrics}>
        <Metric icon="ti-file-invoice" iconColor="var(--accent)" label="Total today"
          value="47" sub="↑ 12 vs yesterday" subClass="up" />
        <Metric icon="ti-circle-check" iconColor="var(--accent)" label="Ready for payment"
          value="31" valueColor="#4dd6a0" sub="₹2.5 Cr cleared" subClass="up" />
        <Metric icon="ti-clock" iconColor="var(--warn)" label="Pending action"
          value="8" valueColor="#D97706" sub="₹40 L missing docs" subClass="warn" />
        <Metric icon="ti-alert-triangle" iconColor="var(--danger)" label="High risk held"
          value="4" valueColor="#DC2626" sub="Requires investigation" subClass="down" />
      </div>

      {/* Row 2 */}
      <div className={s.row2}>
        <Card>
          <CardHead title="Recent invoices"
            action={<span className={s.cardLink} onClick={() => navigate('invoices')}>View all →</span>} />
          <table className={s.table}>
            <thead>
              <tr>
                <th>Invoice no.</th><th>Supplier</th><th>Amount</th><th>Compliance</th><th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{color:'var(--info)'}}>INV-2024-1183</td>
                <td>Bharat Petro Supplies</td><td>₹18.4 L</td>
                <td><span style={{color:'var(--accent)',fontWeight:600}}>94/100</span></td>
                <td><Pill type="ready">Ready</Pill></td>
              </tr>
              <tr>
                <td style={{color:'var(--info)'}}>INV-2024-1182</td>
                <td>Chennai Chemicals Ltd</td><td>₹6.2 L</td>
                <td><span style={{color:'var(--warn)',fontWeight:600}}>72/100</span></td>
                <td><Pill type="pending">Pending</Pill></td>
              </tr>
              <tr>
                <td style={{color:'var(--info)'}}>INV-2024-1181</td>
                <td>Reliance Trading Co.</td><td>₹42.0 L</td>
                <td><span style={{color:'var(--accent)',fontWeight:600}}>89/100</span></td>
                <td><Pill type="ready">Ready</Pill></td>
              </tr>
              <tr>
                <td style={{color:'var(--info)'}}>INV-2024-1180</td>
                <td>IndoLub Pvt Ltd</td><td>₹3.8 L</td>
                <td><span style={{color:'var(--danger)',fontWeight:600}}>41/100</span></td>
                <td><Pill type="risk">High risk</Pill></td>
              </tr>
              <tr>
                <td style={{color:'var(--info)'}}>INV-2024-1179</td>
                <td>Tamil Agro Fuels</td><td>₹11.0 L</td>
                <td><span style={{color:'var(--info)',fontWeight:600}}>81/100</span></td>
                <td><Pill type="review">In review</Pill></td>
              </tr>
            </tbody>
          </table>
        </Card>

        <Card>
          <CardHead title="Avg processing time" />
          <div style={{marginBottom:14}}>
            <BarRow label="Procurement" fillPct={55} fillColor="var(--accent)" value="1.2d" />
            <BarRow label="Operations" fillPct={30} fillColor="var(--info)" value="0.7d" />
            <BarRow label="Finance" fillPct={40} fillColor="var(--warn)" value="0.9d" />
            <BarRow label="CFO" fillPct={20} fillColor="#534AB7" value="0.4d" />
          </div>
          <div style={{borderTop:'1px solid var(--border)',paddingTop:10}}>
            <div style={{fontSize:11,color:'var(--muted)',marginBottom:4}}>Total cycle time</div>
            <div style={{fontSize:24,fontWeight:700,color:'var(--accent)'}}>
              3.2 <span style={{fontSize:13,fontWeight:400,color:'var(--muted)'}}>days avg</span>
            </div>
            <div style={{fontSize:11,color:'var(--accent)',marginTop:2}}>↓ 61% faster than manual</div>
          </div>
        </Card>
      </div>

      {/* Row 3 */}
      <div className={s.row3}>
        <Card>
          <CardHead title="Invoice volume (last 7 days)" />
          <div className={s.barChart}>
            {[50,65,80,55,90,70,100].map((h,i) => (
              <div key={i} className={s.barChartCol}
                style={{height:`${h}%`, background: i===4 ? 'var(--info)' : 'var(--accent)', opacity: i===6||i===4?1:0.5+i*0.07}} />
            ))}
          </div>
          <div className={s.barChartLabels}>
            {['Mon','Tue','Wed','Thu','Fri','Sat','Today'].map(d => <span key={d}>{d}</span>)}
          </div>
        </Card>

        <Card>
          <CardHead title="Compliance distribution" />
          <div style={{marginTop:8}}>
            <BarRow label="90–100 (excellent)" fillPct={62} fillColor="var(--accent)" value="29" />
            <BarRow label="70–89 (good)" fillPct={25} fillColor="var(--info)" value="12" />
            <BarRow label="50–69 (marginal)" fillPct={12} fillColor="var(--warn)" value="5" />
            <BarRow label="Below 50 (risk)" fillPct={2} fillColor="var(--danger)" value="1" />
          </div>
        </Card>

        <Card>
          <CardHead title="Supplier response rate" />
          <div style={{textAlign:'center',padding:'10px 0'}}>
            <div style={{fontSize:36,fontWeight:700,color:'var(--accent)'}}>91%</div>
            <div style={{fontSize:11,color:'var(--muted)',marginBottom:14}}>document submission rate</div>
            <div style={{display:'flex',justifyContent:'space-around'}}>
              <div style={{textAlign:'center'}}>
                <span style={{fontSize:18,fontWeight:700,color:'var(--text)'}}>22</span><br />
                <span style={{fontSize:10,color:'var(--muted)'}}>Active suppliers</span>
              </div>
              <div style={{textAlign:'center'}}>
                <span style={{fontSize:18,fontWeight:700,color:'var(--warn)'}}>3</span><br />
                <span style={{fontSize:10,color:'var(--muted)'}}>Pending KYC</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
